//"use strict";

angular.module('app.factories', [
    'app.factories.apiAlarm',
    'app.factories.controlLogicService',

    'app.factories.devices',
    'app.factories.enum',
    'app.factories.favorite',
    'app.factories.functions',
    'app.factories.info',
    'app.factories.interval',
    'app.factories.rooms',
    'app.factories.user',
    'app.factories.xcenterUtils'

]);
